<div class="page-body step-body desktop-panel desktop-verify" [ngClass]="isDesktop ? 'desktop': 'mobile'" fxLayoutAdivgn="center center">
            <app-close-dialog-button *ngIf="isDesktop && !isFulldataVerification && !isSumsubVerification" (closeEvent)="onCloseEvent($event)"></app-close-dialog-button>

    <div *ngIf="!isReedeemCompleted && !isSmsVerification && !isFulldataVerification && !isSumsubVerification" class="redeem-code-body center" fxLayoutAdivgn="center center">
        <div class="header-div">
            <div class="header-wrapper">
                <img *ngIf="!isDesktop" src="{{licenceService.getKey('promocode-icon')}}" alt="">
                <h1 class="page-header" i18n>{{page?.header}}
                </h1>
            </div>
            <mat-divider *ngIf="isDesktop"></mat-divider>
        </div>
        <!-- <mat-divider></mat-divider> -->
        <div class="page-inner-text" [innerHTML]="body">
        </div>
        <img class="promo-img" src="{{licenceService.getKey('promo-ticket')}}">
    </div>
    <div *ngIf="!isReedeemCompleted && !isSmsVerification && !isFulldataVerification && !isSumsubVerification" class="casino-form-wrapper" fxLayout="row" fxLayoutAlign="center center">
        <div id="casino-form" class="form-custom-design">
            <mat-error *ngIf="hasError" class="error">{{errorMsg}}</mat-error>
            <div fxLayout="row" fxLayoutAlign="center center">
                <form name="redeemCodeForm" [formGroup]="redeemCodeForm" (ngSubmit)="onSubmit(redeemCodeForm)">
                    <mat-form-field appearance="outline">
                        <mat-label i18n>promo code</mat-label>
                        <input matInput type="text" formControlName="code">
                        <img matSuffix src="{{licenceService.getKey('icon-promo-code')}}" class="promo-icon">
                        <mat-error *ngIf="redeemCodeForm.get('code').hasError('required')" i18n>Please provide a promo code.</mat-error>
                    </mat-form-field>
                    <div class="buttons">
                        <div><button round-button filled="filled" color="primary" type="submit" size="large" [disabled]="!redeemCodeForm.valid" class="text-transform-capitalize" i18n>submit</button></div>
                    </div>

                </form>
            </div>
        </div>

    </div>
    <ng-container *ngIf="isSmsVerification">
        <ng-container *ngTemplateOutlet="smsverification"></ng-container>
    </ng-container>
    <ng-container *ngIf="isReedeemCompleted">
        <ng-container *ngTemplateOutlet="completed"></ng-container>
    </ng-container>
    <ng-container *ngIf="isFulldataVerification || isSumsubVerification">
        <ng-container *ngTemplateOutlet="userVerification"></ng-container>
    </ng-container>
</div>
<ng-template #userVerification>
    <div class="user-verify-wrapper">
        <div class="header-title-wrapper">
            <h1 i18n>verification required</h1>
        </div>
        <mat-divider *ngIf="isDesktop"></mat-divider>
        <div class="body-wrapper" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="32px">
            <img class="image-box" src="{{licenceService.getKey('upload-document-img')}}" alt="upload-document-img">
            <div class="edit-profile-wrapper">
                <p i18n>Review your <strong>date of birth</strong> and <strong>postal address</strong> before starting verification. If something doesn’t look right, <a [routerLink]="supportUrl">contact our support</a> team for help.</p>
                <button class="edit-profile-btn" round-button filled="empty" size="large" color="main" [disabled]="!isFulldataVerification" (click)="editProfile()" i18n>Edit Your Profile</button>
            </div>
            <mat-divider></mat-divider>
            <div class="sumsub-wrapper">
                <p i18n>To verify your account, please upload a valid photo ID, a recent proof of address, and a selfie. Verification takes just a few minutes and ensures your account remains secure and fully accessible. Once verified, you’ll unlock all features, rewards, and promotions.</p>
                <button class="verify-profile-btn" round-button filled="filled" size="large" color="main" [disabled]="!isSumsubVerification" (click)="verifyProfile()" i18n>Start Verification</button>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #completed>
    <div class="header-wrapper">
        <img *ngIf="!isDesktop" src="{{licenceService.getKey('promocode-icon')}}" alt="">
        <div class="result" fxLayout="row" fxLayoutAlign="center center" i18n>Promocode applied!</div>
    </div>    
    <mat-divider *ngIf="isDesktop"></mat-divider>
    <div class="complete-msg-wrapper">
    <div class="complete-msg" fxLayout="column" fxLayoutAlign="center center">
        <img src="{{licenceService.getKey('redeem-promo-tick')}}">
        <div class="complete-text">
            <p i18n>Your promo code has been applied, check your bonus queue for details.</p>
        </div>
    </div>
    <div class="buttons completed" [ngStyle]="{'margin': isDesktop ? '32px 0px 59px' : '32px 0px 0px'}">
        <div><button round-button size="large" filled="filled" color="primary" type="submit" [routerLink]="bonusQueueUrl"><span i18n>My Bonuses</span></button></div>
    </div>
    </div>

</ng-template>

<ng-template #smsverification>
    <ng-container *ngIf="!isChangePhone else changephone">
        <div *ngIf="!isReedeemCompleted" class="redeem-code-body center" fxLayoutAdivgn="center center">
            <div class="header-div">
                 <div class="header-wrapper">
                <img *ngIf="!isDesktop" src="{{licenceService.getKey('promocode-icon')}}" alt="">
                <h1 class="page-header" i18n>{{page?.header}}
                </h1>
            </div>
                <mat-divider *ngIf="isDesktop"></mat-divider>
            </div>
            <div class="page-inner-text" [innerHTML]="body">
            </div>
        </div>
        <div class="" fxLayoutAdivgn="center center" fxLayout="column" [ngClass]="isDesktop ? 'desktop': 'mobile'">
            <ng-container>
                <div class="sms-form-wrapper form-custom-design" fxLayoutAlign="center center" fxLayout="column">
                    <div class="promo-value">
                        <p i18n>Promo Code</p>
                        <span i18n>{{redeemCodeForm.value.code}}</span>
                    </div>
                    <div class="verify-code">
                        <img src="{{licenceService.getKey('warning-icon')}}">
                        <p *ngIf="isDesktop" i18n>Please enter the verification code you received via SMS:</p>
                        <p *ngIf="!isDesktop" i18n>To use your promo code please enter the verification code you received via SMS below:</p>
                    </div>
                    <!-- <h3 i18n>Please enter the 5-digit verification code we sent via SMS:</h3>   -->
                    <!-- <span class="additional-info" *ngIf="!detectDesktopService.isDesktop()" i18n>(we want to make sure it's really you)</span> -->
                    <form name="smsForm" [formGroup]="smsForm" (ngSubmit)="onSmsSubmit(smsForm)">
                        <div class="sms-verification-wrapper" fxLayoutGap="5px" fxLayoutAlign="start center" fxLayout="row">
                            <input autocomplete="one-time-code" class="sms-input" #smsinput inputmode="numeric" type="text" pattern="[0-9]" formControlName="code" autofocus>
                        </div>
                        <!-- <div class="no-code">
                                <span class="additional-info" i18n>We want to make sure it's really you</span>
                            </div> -->
                             <div class="no-code">
                            <span i18n class="code-question">Didn't receive the code?</span><br />
                            <div class="cta-btns">
                                <button class="link" (click)="resendCode()"><ng-container i18n>Send code again</ng-container>&nbsp;<ng-container *ngIf="timerValue>0">{{timerValue}}s</ng-container></button>
                                <button class="link1" (click)="isChangePhone=true" i18n>Change phone number</button>
                            </div>
                            <!-- <img src="{{licenceService.getKey('signup-step-three')}}"> -->
                            <app-signup-steps [step]="'three'"></app-signup-steps>
                        </div>
                        <div class="buttons" style="padding-bottom: 0px;margin: 32px 0px 24px !important;">
                            <div><button round-button size="large" filled="filled" color="primary" type="submit" class="text-transform-capitalize"><span i18n>submit</span></button></div>
                        </div>             

                    </form>
                </div>
            </ng-container>
        </div>
    </ng-container>

</ng-template>
<ng-template #changephone>
    <div class="redeem-code-body center" fxLayoutAdivgn="center center" fxLayout="column">
        <div class="header-wrapper">
                <img *ngIf="!isDesktop" src="{{licenceService.getKey('promocode-icon')}}" alt="">
                <h1 class="page-header" [ngStyle]="{'margin':!isDesktop?'0':'0 0 16px'}" i18n>{{page?.header}}
                </h1>
            </div>
        <mat-divider *ngIf="isDesktop"></mat-divider>
        <div class="page-inner-text" [innerHTML]="body">
        </div>
    </div>
    <div class="phone-form-wrapper form-custom-design" fxLayoutAdivgn="center center" fxLayout="column">
        <div class="promo-value">
            <p i18n>Promo Code</p>
            <span i18n>{{redeemCodeForm.value.code}}</span>
            
        </div>
        <div class="verify-code">
            <img src="{{licenceService.getKey('warning-icon')}}">
            <p *ngIf="isDesktop" i18n>Please enter your phone number to receive the verification code via SMS.</p>
            <p *ngIf="!isDesktop" i18n>To use your promo code please enter your phone number to receive the verification code via SMS.</p>
        </div>
        <!-- <div class="info" i18n>
            Please enter your phone number for SMS verification.
        </div> -->
        <div class="change-telephone-form-wrapper">
            <form [formGroup]="changePhoneForm" (ngSubmit)="addPhoneVerification(changePhoneForm)">
                <div class="telephoneContainer" fxLayout="row" fxLayoutAlign="center center">
                    <mat-form-field class="ccode" appearance="outline">
                        <mat-label i18n>country prefix</mat-label>
                        <select matNativeControl name="car" [(ngModel)]="prefixCountry" [ngModelOptions]="{standalone: true}" (change)="triggerTelephoneChange()">
                            <option *ngFor="let code of countryCodes" [value]="code.dial_code">{{ code.dial_code }} {{ code.name }}
                            </option>
                        </select>
                    </mat-form-field>
                    <mat-form-field class="telephone" appearance="outline">
                        <mat-label i18n>telephone number</mat-label>
                        <input matInput [(ngModel)]="telephoneSuffix" [ngModelOptions]="{standalone: true}" name="telephoneSuffix" (change)="triggerTelephoneChange()">
                    </mat-form-field>
                    <div class="errorMsgTelephone">
                        <span class="error" *ngIf="!isTelephoneValid" i18n>Please enter the correct phone number.</span>
                    </div>
                    <input type="hidden" formControlName="telephone" />
                </div>
                <div class="buttons" [ngStyle]="{'margin': isTelephoneValid ? '10px 0 0 0' : '22px 0 0 0'}">
                    <div><button round-button size="large" filled="filled" [class.spinner]="formSubmited" color="primary" type="submit" class="text-transform-capitalize"><span *ngIf="!formSubmited" i18n>submit</span><span *ngIf="formSubmited">&nbsp;</span></button></div>
                </div>
            </form>
        </div>
        <div class="no-code">
            <!-- <img src="{{licenceService.getKey('signup-step-three')}}"> -->
            <app-signup-steps [step]="'three'"></app-signup-steps>
            <!-- <button class="link" round-button size="large" filled="empty" (click)="isChangePhone=false" i18n>cancel</button> -->
        </div>
    </div>
</ng-template>

<ng-container *ngIf="pageView === 'OPENCHANGENUMBERMODAL'">
    <div class="success-popup" [ngClass]="{'desktop': isDesktop, 'mobile': !isDesktop}">
        <div class="success-content">
            <div class="success-header">
                <h2 i18n>Success!</h2>
                <app-close-dialog-button [customClass]="'medium'" (closeEvent)="closeDialog()" [position]="true"></app-close-dialog-button>
            </div>
            <div class="success-body">
                <mat-divider></mat-divider>
                <!-- <div class="image-box">
                    <img src="assets/images/phone-img.svg">
                </div> -->
                <div class="success-txt">
                    <p i18n>Your phone number has been updated!</p>
                </div>
                <div class="success-button">
                    <button (click)="closeDialog()" i18n>ok</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="pageView === 'OPENMODAL'">
    <div class="success-popup" [ngClass]="{'desktop': isDesktop, 'mobile': !isDesktop}">
        <div class="success-content">
            <div class="success-header">
                <h2 i18n>Success!</h2>
                <app-close-dialog-button [customClass]="'medium'" (closeEvent)="closeDialog()" [position]="true"></app-close-dialog-button>
            </div>
            <div class="success-body">
                <mat-divider></mat-divider>
                <!-- <div class="image-box">
                    <img src="{{licenceService.getKey('redeem-promo-tick')}}">
                </div> -->
                <div class="success-txt">
                    <p i18n>Your SMS code has been resent.</p>
                </div>
                <div class="success-button">
                    <button (click)="closeDialog()" i18n>ok</button>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<router-outlet></router-outlet>